<div class="app-container">
    <div>
        Container
    </div>
</div>